import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ImproveTemplateInput, ImproveTemplateOutput } from '../types';
import { iaService } from './services';

interface IaState {
  isImproving: boolean;
  improvedContent: ImproveTemplateOutput | null;
  error: string | null;
}

const initialState: IaState = {
  isImproving: false,
  improvedContent: null,
  error: null,
};

export const improveTemplate = createAsyncThunk(
  'ia/improveTemplate',
  async (data: ImproveTemplateInput, { rejectWithValue }) => {
    try {
      const response = await iaService.improveTemplate(data);
      return response.data;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

const iaSlice = createSlice({
  name: 'ia',
  initialState,
  reducers: {
    clearImprovedContent: (state) => {
      state.improvedContent = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(improveTemplate.pending, (state) => {
        state.isImproving = true;
        state.error = null;
      })
      .addCase(improveTemplate.fulfilled, (state, action) => {
        state.isImproving = false;
        state.improvedContent = action.payload;
      })
      .addCase(improveTemplate.rejected, (state, action) => {
        state.isImproving = false;
        state.error = action.payload as string;
      });
  },
});

export const iaReducer = iaSlice.reducer;
